import $ from 'jquery';
import { InventorySearchEvents } from '../events';

export class Renderer {
  #container;
  #clearChildrenSelector;
  #loader;
  #events = {
    prerender: InventorySearchEvents.PRE_RENDER,
    postrender: InventorySearchEvents.POST_RENDER,
  };

  constructor({ rootSelector, clearChildrenSelector, loaderSelector, events = {} }) {
    this.#container = $(rootSelector);
    this.#clearChildrenSelector = clearChildrenSelector;
    this.#loader = $(loaderSelector);

    this.#events = {
      ...this.#events,
      ...events,
    };
  }

  render(content) {
    $(document).trigger(this.#events.prerender, [this.#container]);
    this.hideLoader();

    // Swap the results node in place instead of refilling the container.
    // Themes are free to render the filter/sort UI and the loader as siblings
    // of the results inside the root, so anything that empties the root takes
    // them with it and they only come back on a full page load.
    const results = this.#results();
    if (results.length) {
      results.replaceWith(content);
    } else {
      this.#container.append(content);
    }

    $(document).trigger(this.#events.postrender, [this.#container]);
  }

  showLoader() {
    this.#loader.show();
  }

  hideLoader() {
    this.#loader.hide();
  }

  clearChildren() {
    const results = this.#results();

    // Clear the results the loader stands in for, leaving the rest of the
    // container — filters, sort, the loader itself — in place.
    if (results.length) {
      results.empty();
    } else {
      this.#container.empty();
    }
  }

  // The results node, when the caller named one and it is still in the DOM.
  #results() {
    if (!this.#clearChildrenSelector) {
      return $();
    }

    return this.#container.find(this.#clearChildrenSelector);
  }
}
